export default "__VITE_PUBLIC_ASSET__2182eea2__"